import React from 'react';

import styles from './MetadataItem.module.css';

type MetadataItemProps = {
  icon?: React.ReactNode;
  title: string;
  children: React.ReactNode;
};

export const MetadataItem = React.forwardRef<HTMLDivElement, MetadataItemProps>(({ icon, title, children }, ref) => {
  return (
    <div className={styles.metadataItem} ref={ref}>
      {icon && <div className={styles.metadataIcon}>{icon}</div>}
      <div className={styles.metadataContent}>
        <div className={styles.metadataTitle}>{title}</div>
        <div className={styles.metadataLabel}>{children}</div>
      </div>
    </div>
  );
});

MetadataItem.displayName = 'MetadataItem';
